import React from 'react';
import './index.css';

const AssignmentTile = props => {
    return (
        <div className="tile" onClick={props.handleClick}>
            <div className="leftHalf">
                <h3>{props.name}</h3>
                <h1>{props.number}</h1>
                <h3 onClick={props.handleRelease} className="assignmentTileButton">{props.status}</h3>
            </div>
            <div className="rightHalf">
                <div><h2>{props.dueDate}</h2></div>
                <h4>{props.grade}</h4>
            </div>
        </div>
    )
}

export default AssignmentTile;
